const routes = {
  adminDashboard: `/admin`,
  adminTeam: `/admin/team`,
  adminTemplates: `/admin/templates`,
  adminAccount: `/admin/account`,
  adminBilling: `/admin/billing`,

  SA_Negotiator: `/`,
  SA_Core: `/core`,
  SA_NegotiatorDetails: `/negotiator`,
  SA_Unified_Users: `/unified-users`,
  SA_Artifacts: `/artifacts`,
  SA_MarkupMargins: '/markup-margins',
  SA_AiModels: '/ai-models',
  SA_Lookups: '/lookups',
  SA_Analytics: '/analytics',
  SA_BillingAccounts: `/billings`,
  SA_BillingTokens: `/billing-tokens`,
  SA_Bills: `/bills`,
  SA_Settings: `/settings`,
  SA_MyProfile: `/settings/my-profile`,
  SA_ApiKeys: `/settings/apis`,
  SA_OAuthGhl: `/oauth/core`,
  SA_CustomValues: `/customvalues`,
  SA_ZazuAuditTrails: `/zazu-audit-trails`,
  SA_Jobs: `/jobs`,
  SA_Diagnostics: `/extension-health/diagnostics`,
  SA_SupportTickets: `/extension-health/support-tickets`,
  SA_DiagnosticsLookup: `/extension-health/lookup`,
  SA_ApiDocs: `/api-docs`,
  SA_Roles: `/roles`,
  logout: `/logout`
};

const tableDefaults: TableDefaults = {
  perPage: 10,
  maxPerPage: 100,
  orderBy: ``
};

// Category the generic Lookups table uses for platform-wide pricing parameters.
const LOOKUP_CONFIG_CATEGORY = 'config';

// The AI tier zazu switches to when a provider call fails on an account's own
// tier. It is an ordinary MarkupMargins row so that fallback usage is priced and
// reported like any other AI traffic, but it is billing configuration rather than
// a sellable plan — it must never be offered as a priceModel. Which row plays the
// part is data (`config / ai_fallback_markup_type`); the slug below is only the
// default used when that lookup row is missing.
const FALLBACK_MARKUP_TYPE_KEY = 'ai_fallback_markup_type';
const DEFAULT_FALLBACK_MARKUP_TYPE = 'ai_processing_sr_hz';

export {
  routes,
  tableDefaults,
  LOOKUP_CONFIG_CATEGORY,
  FALLBACK_MARKUP_TYPE_KEY,
  DEFAULT_FALLBACK_MARKUP_TYPE
};
